/**
 * Root component de `apps/web` — Fase 5.
 *
 * Integra TanStack Router como capa de navegación dentro de los
 * providers de datos (Query + PowerSync).
 */

import type { Component } from "solid-js";
import { RouterProvider } from "@tanstack/solid-router";

import { AppProviders } from "@/providers/app-providers";
import { router } from "@/router";

export const App: Component = () => (
  <AppProviders>
    <RouterProvider router={router} />
  </AppProviders>
);
